"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M15 4.01H5c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h10c.55 0 1-.45 1-1v-10c0-.56-.45-1-1-1z"];
//# sourceMappingURL=symbol-square.js.map